export default {
  free_menu_items: 'Odblokowano gratis',
  discount_badge: '{{value}} zniżki',
  available_at_badge: 'Dostępne {{schedule}}',
  restricted_tooltip: 'Dostępne {{schedule}} — zmień godzinę odbioru powyżej, aby zamówić.',
};
